<template>
  <Popup
    v-model="show"
    get-container="body"
    overlay-class="billing-detail-reset"
  >
    <slot name="title"> </slot>
    <slot name="content">
      <div class="reset-content">
        <div>是否确定</div>
        <div>撤销该发票申请</div>
      </div>
    </slot>

    <slot name="footer">
      <div class="reset-footer">
        <div @click="closePop">取消</div>
        <div class="confirm" @click="confirm">确认</div>
      </div>
    </slot>
  </Popup>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';

@Component({
  components: {
    Popup,
  },
})
export default class ResetComfirm extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  value!: boolean;

  get show() {
    return this.value;
  }
  set show(value: boolean) {
    if (!value) {
      this.$emit('input', false);
    }
  }

  confirm() {
    this.$emit('handleResetComfirm');
    this.closePop();
  }

  closePop() {
    this.show = false;
  }
}
</script>
<style lang="scss" scoped>
@import '../../../style/index.scss';
.reset-content {
  @include wid_hei(480px, 170px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: $_base_color;
  text-align: center;
}
.reset-footer {
  @include wid_hei(480px, 106px);
  display: flex;
  align-items: center;
  padding: 17px 0;
  border: 1px solid $_reset_gray;
}
.reset-footer div {
  width: 50%;
  padding: 15px 0;
  text-align: center;
}
.confirm {
  color: $_base_light_purple;
  border-left: 1px solid $_reset_gray;
}
</style>
<style lang="scss">
.billing-detail-reset + .van-popup {
  border-radius: 16px;
}
</style>